import { SET_USER_DATA, SET_USER_LIST, SET_USER_PAGINATION } from "../ActionName/ActionName";


const initialState = {
    user: null,
    userList: [],
    pagination: {
        page: 1,
        limit: 10,
        total: 0,
        totalPages: 0,
        hasNextPage: false,
        hasPrevPage: false,
        search: {}
    },
    timestamp: Date.now()
}

const UserReducer = (state = initialState, action) => {

    switch (action.type) {
        case SET_USER_DATA:
            return {
                ...state,
                user: action.value,
                timestamp: Date.now()
            }

        case SET_USER_LIST:
            return {
                ...state,
                userList: action.value || [],
                timestamp: Date.now()
            }

        case SET_USER_PAGINATION:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.value
                },
                timestamp: Date.now()
            }

        default:
            return state;
    }
}

export default UserReducer;